import { MetadataDisplayType } from '@model/enums/metadataDisplayType';

export class DTO_ChangeableParameter {
    "@type": string;
    name: string;
    metadataDisplayType: MetadataDisplayType;
    metadataDisplayName: string;
}